<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3322_71282)">
            <path d="M7.0239 8.99902H3.26953V21H7.0239V8.99902Z" fill="black" />
            <path
                d="M20.5521 14.5657V21.0001H16.7978V15.0011C16.7978 13.4235 16.6084 12.1457 14.7708 12.1457C12.9331 12.1457 12.7466 13.4264 12.7466 15.0011V21.0001H8.99219V8.99915H12.7466V10.7152C13.312 9.46844 14.3806 8.67969 16.3567 8.67969C16.5094 8.67969 16.6564 8.68534 16.7978 8.69382C20.1874 8.89455 20.5521 11.4446 20.5521 14.5657Z"
                fill="black"
            />
            <path
                d="M7.3 5.14859C7.3 3.96121 6.33596 3 5.14859 3C3.96121 3 3 3.96121 3 5.14859C3 6.33596 3.96121 7.29717 5.14859 7.29717C6.33596 7.29717 7.29717 6.33596 7.29717 5.14859H7.3Z"
                fill="black"
            />
        </g>
        <defs>
            <clipPath id="clip0_3322_71282">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>
